import { useCallback, useEffect, useState } from 'react'

import { datadogLogs } from '@datadog/browser-logs'

import { fetchMotivations } from '@library/api-motivations'
import { queueTrackingEvent } from '@library/tracking-integration'

const trackSkipOnError = () => {
  queueTrackingEvent<{
    action: 'skip_motivations'
    properties: {
      error: 1
    }
  }>({
    action: 'skip_motivations',
    properties: {
      error: 1,
    },
  })
}

export function useSignupMotivations() {
  const [motivations, setMotivations] = useState<{ id: string; title: string }[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<boolean>(false)

  const fetchMotivationsData = useCallback(async () => {
    setLoading(true)
    setError(false)
    try {
      const response = await fetchMotivations()
      if (Array.isArray(response) && response.length > 0) {
        setMotivations(response)
      } else {
        setMotivations([])
        setError(true)
        trackSkipOnError()
      }
    } catch (err: unknown) {
      datadogLogs.logger.error(
        'Fetching Motivations failed:',
        err instanceof Error ? err : new Error('Unknown error'),
      )
      setMotivations([])
      setError(true)
      trackSkipOnError()
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchMotivationsData()
  }, [fetchMotivationsData])

  return { motivations, loading, error }
}
